import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=4cf2b3a8&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "./Logo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cf2b3a8')) {
      api.createRecord('4cf2b3a8', component.options)
    } else {
      api.reload('4cf2b3a8', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=4cf2b3a8&", function () {
      api.rerender('4cf2b3a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/search/components/Logo.vue"
export default component.exports